/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 8,
    height: 16,
    viewBox: '0 0 8 16',
    data: '<path pid="0" d="M0 0h1v16H0V0zm7 0v16h1V0H7z"/>'
  }
})
